import * as yup from 'yup';
import { isVollversicherung } from '@/features/Sparten/pkv/formConfigs/sharedRenderConditions';

export enum PKV_PREVIOUS_INSURANCE_TYPE {
  PRIVATE = 'privat',
  PUBLIC = 'gesetzlich',
}

export const productSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().required(),
  closeDate: yup.string().required(),
  isClosed: yup.boolean().optional(),
  price: yup.number().optional().nullable().default(null),
});

export type ProductSchema = yup.Asserts<typeof productSchema>;

export const previousInsuranceSchema = yup.object({
  aktiv: yup.boolean().default(false),
  art: yup
    .string()
    .default(PKV_PREVIOUS_INSURANCE_TYPE.PRIVATE)
    .when('aktiv', {
      is: (aktiv: boolean) => aktiv && isVollversicherung.value,
      then: yup
        .string()
        .required()
        .oneOf([
          PKV_PREVIOUS_INSURANCE_TYPE.PRIVATE,
          PKV_PREVIOUS_INSURANCE_TYPE.PUBLIC,
        ]),
    }),
  gesellschaft: yup
    .number()
    .default(0)
    .when(['art', 'aktiv'], {
      is: (art: PKV_PREVIOUS_INSURANCE_TYPE, aktiv: boolean) =>
        aktiv && art === PKV_PREVIOUS_INSURANCE_TYPE.PRIVATE,
      then: yup.number().required(),
    }),
  berufsgruppe: yup.string().default(''),
  berufsstatus: yup.string().default(''),
  tarifBausteine: yup
    .array()
    .of(productSchema)
    .default([])
    .when('aktiv', {
      is: (val: boolean) => val,
      then: yup
        .array()
        .min(1, 'Bitte wählen Sie einen Vorversicherungstarif aus.'),
    }),
  einzelbeitraege: yup.boolean().default(false),
  beitrag: yup.number().nullable().default(null),
  arbeitsgeberanteil: yup.object({
    kv: yup.number().nullable().default(null),
    ppv: yup.number().nullable().default(null),
  }),
});

export type PreviousInsuranceSchema = yup.Asserts<
  typeof previousInsuranceSchema
>;
